import React, { useRef, useContext, useState, useEffect } from 'react';
import { Alert, Button, FormControl, IconButton, InputLabel, MenuItem, Select, Snackbar, TextField, Switch, FormGroup, FormControlLabel, CircularProgress, SnackbarContent } from '@mui/material';
import AuthContext from '../../../context/AuthContext';
import DrawerContext from '../../../context/DrawerContext';

import { EditorToolbar, BlogEditorContent, useBlogEditor } from "./EditorToolbar";
import { AddRounded, ArrowBackIos, ArrowBackRounded, ArrowForwardIosRounded, ArrowForwardRounded, CloseRounded, HighlightOffRounded, KeyboardArrowDownRounded, KeyboardBackspace, PublishRounded, Remove, ReplayRounded, Upload } from '@mui/icons-material';
import GetImage from '../../../common/GetImage';

import placeholder from '../../../assets/img/placeholder.png';
import backbutton from '../../../assets/img/drawer/back.svg';

// import Flower1 from '../../../assets/img/blog/edit/blog-edit-flower-1.png'
// import Flower2 from '../../../assets/img/blog/edit/blog-edit-flower-2.png'

import Logo from '../../../assets/img/deliva_icon.svg';
import DefaultImage from "../../../assets/img/blog/edit/default.jpg";

import ModalContext from '../../../context/ModalContext';

//mui
import { styled } from '@mui/material/styles';
import StayCurrentLandscapeIcon from '@mui/icons-material/StayCurrentLandscape';
import StayCurrentPortraitIcon from '@mui/icons-material/StayCurrentPortrait';
import { PUBLIC_BLOG_URL, getPost, updatePost } from '../../blogApi';

const ScreenOrientationBtn = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 56, // Updated width
  height: 28, // Updated height
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(28px)', // Adjusted for new width
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: '#1ABC9C', // Updated background color when checked
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: theme.palette.mode === 'dark' ? theme.palette.grey[900] : theme.palette.grey[700],
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: theme.palette.mode === 'dark' ? 0.3 : 0.7,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 24, // Adjusted thumb size to fit new switch size
    height: 24,
  },
  '& .MuiSwitch-track': {
    borderRadius: 24, // Updated border-radius
    backgroundColor: theme.palette.mode === 'dark' ? '#39393D' : '#C6C6C6',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 300,
    }),
  },
}));



const EditBlogDrawer = ({ drawerDetails }) => {

  // console.log(drawerDetails);


  //refs
  const titleRef = useRef(null);

  //context
  const authCtx = useContext(AuthContext);
  const drawerCtx = useContext(DrawerContext);
  const modalCtx = useContext(ModalContext);

  //states
  const [open, setOpen] = useState(false);
  const [metaTagsOpen, setMetaTagsOpen] = useState(false);
  const [editorToolOpen, setEditorToolOpen] = useState(true);
  const [tagsTopicBarOpen, setTagsTopicBarOpen] = useState(true);
  const [blogVideoToggle, setBlogVideoToggle] = useState(false);

  // updating status states 
  const [blog, setBlog] = useState(drawerDetails);

  //Dummy Data
  const [topics, setTopics] = useState(blog.topics && blog.topics.length > 0 ? blog.topics : []);

  const [tags, setTags] = useState(blog.tags && blog.tags.length > 0 ? blog.tags : []);
  



  const toInputDate = (dateVal) => {
    const d = dateVal ? new Date(dateVal) : null;
    return d && !isNaN(d.getTime()) ? d.toISOString().slice(0, 10) : '';
  };
  const toPublishedAt = (inputDate) => {
    const today = new Date().toISOString().slice(0, 10);
    return inputDate === today ? new Date().toISOString() : `${inputDate}T00:00:00.000Z`;
  };
  const [date, setDate] = useState(() => toInputDate(blog?.publishedAt));
  const [imageDirection,setImageDirection] = useState(true);
  const [image, setImage] = useState(blog?.coverImageUrl || DefaultImage);
  const [updatingStatus, setUpdatingStatus] = useState(false);
  const [updatingStatusId, setUpdatingStatusId] = useState();
  const [savingChanges, setSavingChanges] = useState(false);
  const [saveError, setSaveError] = useState(null);

  const [createBlogObj, setBlogObj] = useState({
    snippet: blog?.excerpt || "",
    title: blog?.title || "",
    post: blog?.content || "",
    slug: blog?.slug || "",
    pageTitle: blog?.seo?.title || "",
    metaDescription: blog?.seo?.description || "",
  });
  const [authors, setAuthors] = useState([]);
  const [selectedAuthors, setSelectedAuthors] = useState([]);
  const [author, setAuthor] = useState('');
  const [blogUrl, setBlogUrl] = useState(blog?.slug);
  const [slug, setSlug] = useState(blog?.slug);
  const [updateBlogStatus, setUpdateBlogStatus] = useState(false);
  const [statusClass, setStatusClass] = useState(() => {
    if (blog?.status === 'published') {
      return 'status-button published';
    } else {
      return 'status-button';
    }
  });
  const editor = useBlogEditor(createBlogObj.post, (html) => setBlogObj((prev) => ({ ...prev, post: html })));

  //styles
  const containerStyles = {
    width: imageDirection ? "40%" : "100%",
    height: "auto",
    // flexDirection: imageDirection ? "column" : "row",
  };

  //effect
  useEffect(() => {

    if (titleRef && titleRef.current) {
      titleRef.current.innerText = blog?.title;
    }

  }, [blog]);

  const handleTitleInput = (e) => {
    setBlogObj((prev) => ({ ...prev, title: e.target.innerText }))
  }

  //functions
  /**
   * One PATCH covers everything, slug included — blog-api records the outgoing
   * slug in post_slug_history so the old URL keeps resolving, which is why
   * there is no separate updateSlug call any more.
   */
  const submitEditBlog = async () => {
    setSavingChanges(true);
    setSaveError(null);

    const { title, snippet, post, slug: nextSlug, pageTitle, metaDescription } = createBlogObj;
    const currentSlug = blog?.slug;

    try {
      const updated = await updatePost(currentSlug, {
        title,
        coverImageUrl: image && image !== DefaultImage ? image : null,
        excerpt: snippet || null,
        content: post || '<p></p>',
        ...(nextSlug && nextSlug !== currentSlug ? { slug: nextSlug } : {}),
        ...(date && date !== toInputDate(blog?.publishedAt) ? { publishedAt: toPublishedAt(date) } : {}),
        seo: { title: pageTitle || null, description: metaDescription || null },
      });

      setBlog(updated);
      setSlug(updated.slug);
      setBlogUrl(updated.slug);
      setSavingChanges(false);
      drawerCtx.setPageUpdate({ page: 'Blogs' });
    } catch (err) {
      console.error(err);
      setSaveError(err.message);
      setSavingChanges(false);
    }
  }

  const closeDrawer = () => {
    drawerCtx.closeDrawer();

  }

  const getBlog = async () => {
    if (!blog?.slug) return;
    try {
      const updatedBlog = await getPost(blog.slug);
      setBlog(updatedBlog);
      updateStatusClass();
      setAuthors(updatedBlog.author ? [updatedBlog.author] : []);
      setTags(updatedBlog.tags ?? []);
      setTopics(updatedBlog.topics ?? []);
      setImage(updatedBlog.coverImageUrl || DefaultImage);
      setDate(toInputDate(updatedBlog?.publishedAt));
    } catch (err) {
      console.error(err);
      setSaveError(err.message);
    }
  }
  useEffect(() => {
    getBlog();
  }, []);

  const updateStatusClass = () => {
    if (blog?.status === 'published') {
      setStatusClass('status-button published');
    } else {
      setStatusClass('status-button');
    }
  }


  const handleImageUpload = () => {
    modalCtx.setDetails('upload-fixed-image', {
      aspectRatio: 1.6,
      origin: 'blog',
      slug: blog.slug,
      blog: blog,
      onSuccess: (newImageUrl) => setImage(newImageUrl),
    });
    modalCtx.openModal();
  }
  
  const handleModal = (modal, data) => {
    modalCtx.setDetails(modal, {
      ...data,
      onClose: getBlog, // Pass the callback here
    });
    modalCtx.openModal();
  };



  const handleClose = () => {
    setOpen(false);
  };

  const removeSingleTopic = (indexToRemove) => {
    blog?.topics.splice(indexToRemove, 1);
    console.log(blog);

  }



  //functions
 

  const handleDateChange = (e) => {
    setDate(e.target.value); // Update state when the user edits the date
  };
  const toggleImageDirection = () => {
    setImageDirection(!imageDirection); // Toggle between portrait and landscape
  };
  const handleRemoveImage = () => {
    setImage(DefaultImage); // Set the image to DefaultImage
  };


  





  const DeleteTopic = () => handleModal('edit-blog-topics', blog);


  const DeleteTag = () => handleModal('edit-blog-tags', blog);

  const openPublishModal = (blog) => {
    modalCtx.setDetails('confirm-publish-blog', { blog });
    modalCtx.openModal();
    getBlog();
  }





  function showRegDate(unFormattedDate) {
    if (unFormattedDate == null || unFormattedDate === undefined) return '—';
    const date = new Date(unFormattedDate);
    if (isNaN(date.getTime())) return '—';
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return date.toLocaleDateString('en-US', options);
  }

  const handleMetaTagsBoolean = (e) => {
    if (e) {
      setMetaTagsOpen(true)
    } else {
      setMetaTagsOpen(false)
    }
  }

  const handleEditorToolBoolean = () => {
    if (editorToolOpen) {
      setEditorToolOpen(false)
    } else {
      setEditorToolOpen(true)
    }
  }

  const handleTagsTopicBoolean = () => {
    if (tagsTopicBarOpen) {
      setTagsTopicBarOpen(false)
    } else {
      setTagsTopicBarOpen(true)
    }
  }

  return (

    <div className="edit-blog-container">
      <div className="drawer blog-drawer-container">
        <div className="blog-drawer" style={editorToolOpen ? { gridTemplateRows: '160px 1fr 100px' } : { gridTemplateRows: '115px 1fr 100px' }}>

          <div className="blog-drawer-header">
            <header style={{ backgroundColor: "#E5E5E8",padding:"20px"}}>
              <h1 data-aos="fade-right" data-aos-delay="500" style={{color:"black"}}>
                < img className='back-button tool-button' onClick={(e) => {
                  closeDrawer();
                }} src={backbutton} alt='' />
                Edit Blog - {createBlogObj.title}</h1>
            </header>

            <div className="blog-webpage-clone">
              <div className="webpage-clone">
                <div className="webpage-link" style={{backgroundColor:"white", boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.2)"}}>
                  <ArrowBackRounded style={{ color: '#aaa' }} className='link-icon' />
                  <ArrowForwardRounded style={{ color: '#aaa' }} className='link-icon' />
                  <ReplayRounded style={{ color: '#aaa' }} className='link-icon' />
                  <div className="link-container">
                    <span>{PUBLIC_BLOG_URL}/</span>
                    <input type="text" name="slug" value={createBlogObj.slug} placeholder="post-url-slug" onChange={(e) => setBlogObj((prev) => ({ ...prev, [e.target.name]: e.target.value }))} />
                  </div>
                </div>
                <div className="title-tab" style={{backgroundColor:"white"}}>
                  <img src={Logo} alt="logo" />
                  <span>{createBlogObj.title}</span>
                  <CloseRounded style={{ color: '#aaa' }} />
                </div>

                <div className='action-buttons-div'>
                  <FormGroup>
                  <FormControlLabel
                      control={<ScreenOrientationBtn sx={{ m: 1 }} checked={metaTagsOpen} onChange={e => setMetaTagsOpen(e.target.checked)} />}
                      label="Meta Tags"
                    />
                  </FormGroup>
                  <button
                    className="btn-primary"
                    variant="contained"
                    component="label"
                    disabled={false}
                    onClick={(e) => submitEditBlog()}
                    style={{ backgroundColor: "#1359E4", color: "white" }}
                  >
                    {savingChanges ? (
                      <CircularProgress style={{ color: "white", background: "#1359E4" }} size={20} />
                    ) : (
                      "Save Changes"
                    )}
                  </button>
                  <button
                    className="btn-primary-border"
                    variant="outlined"
                    component="label"
                    disabled={false}
                    onClick={(e) => closeDrawer()}
                    style={{
                      backgroundColor: "#E5E5E8", 
                      color: "#1359E4",           // Text color
                      borderColor: "#1359E4",     
                    }}
                  >
                    Cancel
                  </button>

                </div>

                <div
                  className="meta-tags-container"
                  style={{
                    backgroundColor: "#F6F7FA",
                    flexDirection: 'row',
                    gap: '15px', // Adjust spacing between the fields
                    alignItems: 'center',
                    zIndex: 1,
                    display: metaTagsOpen ? "flex" : "none",
                   
                  }}
                >
                  {/* Conditionally render the TextFields based on metaTagsOpen */}
                  {metaTagsOpen && (
                    <>
                    <TextField
                      style={{}}
                      name="metaDescription"
                      label="Meta Description"
                      value={createBlogObj.metaDescription}
                      onChange={(e) =>
                        setBlogObj((prev) => ({
                          ...prev,
                          [e.target.name]: e.target.value,
                        }))
                      }
                      placeholder="Meta Description"
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                      required
                    />
                  </>
                  )}
                </div>

              </div>
            </div>
            <div className="editor-toolbar-container" style={{
               marginTop: metaTagsOpen ? "130px" : "0px",position: "relative", zIndex: 2 ,background:"#FFFFFF 0% 0% no-repeat padding-box",padding:"10px",height:"64px"
            }}>
              <div className="editor-toolbar-control">
                <KeyboardArrowDownRounded style={editorToolOpen ? { transform: 'rotateX(180deg)' } : null} onClick={() => handleEditorToolBoolean()} />
              </div>
              <EditorToolbar editor={editor} editorToolOpen={editorToolOpen} />
            </div>
          </div>

          <div className='blog-edit-section'
            style={{
              margin: metaTagsOpen ? "250px 10% 30px 10%" : "100px 10% 30px 10%",
            }} >
            <div className='editor-div'>

              <div className="image-and-title-container" style={{flexDirection: !imageDirection ? "column" : "row",}}>
                <div className='image-container' style={containerStyles}>
                    <div className='image-change-btn'>
                    {imageDirection ? (
                      <StayCurrentLandscapeIcon 
                        className="landscape-btn" 
                        onClick={toggleImageDirection} 
                      />
                    ) : (
                      <StayCurrentPortraitIcon 
                        className="portrait-btn" 
                        onClick={toggleImageDirection} 
                      />
                    )}
                    </div>

                    <div className="img">
                    <img
                      className={`post-image ${image === DefaultImage ? "placeholder" : ""}`}
                      src={image}
                      alt={blog?.title || "Blog Post"}
                    />
                    <div className="upload-image-buttons" >
                      <button className="btn-primary" onClick={handleImageUpload}>
                        <PublishRounded className="buttons" />
                        {image !== DefaultImage ? "Update Image" : "Add Image"}
                      </button>

                      {/* Existing Remove Image Button */}
                      {image !== DefaultImage && (
                        <button className="btn-primary-border" onClick={handleRemoveImage}>
                          <HighlightOffRounded className="buttons" /> Remove Image
                        </button>
                      )}
                    </div>
                  </div>
                </div>

                <div className='title-and-author-container' style={{width: !imageDirection ? "100%" : "60%",}}>
                  <div className='title-and-author'>
                    <div className="blog-author-and-date">
                      <input
                        type="text"
                        type="date"
                        title="Publish date"
                        value={date}
                        onChange={handleDateChange}
                        placeholder="Enter Date"
                        className="date-editor"
                      />
                    </div>

                    <div className='author-row'>
                      {(authors || []).filter((a) => a != null).map((author) => (
                        <div key={author.slug} className="author-container">
                          <span className="blog-author" onClick={() => handleModal('edit-blog-author', blog)}>
                            {author?.name ?? 'Unknown'}
                          </span>
                        </div>
                      ))}

                      <div className='author-tag' onClick={() => handleModal('edit-blog-author', blog)}><AddRounded className='add-author' /> Author</div>
                    </div>

                    <div className="title-container">
                      {/* <div contentEditable={true} className='title-editor' role="textbox" spellcheck="true" onInput={(e) => } placeholder="Title" >{createBlogObj.title}</div> */}
                      <div ref={titleRef} contentEditable={true} className='title-editor' onInput={handleTitleInput}></div>
                    </div>
                  </div>
                </div>
              </div>

              <div className='content-container'>
                <div className='text-editor-container'>
                  <BlogEditorContent editor={editor} />
                </div>
              </div>
            </div>

          </div>

          <div className='tags-container'>
            <div className='topic-row'>
              <div className='single-tag' onClick={() => handleModal('edit-blog-topics', blog)}><AddRounded className='add-author' /> Topics</div>
              <div className='topic-collection'>
                {
                  topics.map((topic, index) => {
                    return (
                      <div key={topic.slug} className="single-tag">
                        {topic.name}
                        <CloseRounded
                          className="remove-author"
                          onClick={() => DeleteTopic()}
                        />
                      </div>
                    );
                  })
                }

              </div>
            </div>

            <div className='tags-row'>
              <div className='single-tag' onClick={() => handleModal('edit-blog-tags', blog)}><AddRounded className='add-author' /> Tag</div>
              <div className='tags-collection'>
              {
                tags.map((tag, i) => {
                  return (
                    <div key={tag.slug} className="single-tag">
                      {tag.name}
                      <CloseRounded
                        className="remove-author"
                        onClick={() => DeleteTag()}
                      />
                    </div>
                  );
                })
              }
              </div>
              {/* <div className='single-tag' onClick={null}><CloseRounded className='add-author' onClick={() => null} /> Prayer</div> */}
            </div>

            <div className='status-container'>
              <div className='status-date'>
                Created On {showRegDate(blog?.publishedAt)}
              </div>
              <div className='status'>
                <p>Status - </p> 
                <div className="author-tags" onClick={() => openPublishModal(blog)}>
                  <span className={statusClass}>{blog?.status.toUpperCase()}</span>
                </div>
              </div>
              
            </div>
          </div>
        </div>
      </div>

      <Snackbar
        open={open}
        autoHideDuration={2000}
        onClose={handleClose}
      >
        <SnackbarContent style={{
          backgroundColor: 'teal',
          borderRadius: "10px",
          color: "white",
        }}
          message={<span id="client-snackbar">Post Saved</span>}
        />
      </Snackbar>
    </div>
  );
}

export default EditBlogDrawer;

